import type { Locale } from '#shared/types/users.ts'

type FormatterKey = 'kilometer' | 'meter' | 'currency' | 'largeNumbers'

const formatterMap: Record<FormatterKey, Record<Locale, Intl.NumberFormat>> = {
  kilometer: {
    nl: new Intl.NumberFormat('nl-NL', {
      style: 'unit',
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
      unit: 'kilometer'
    }),
    en: new Intl.NumberFormat('en-GB', {
      style: 'unit',
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
      unit: 'kilometer'
    })
  },
  meter: {
    nl: new Intl.NumberFormat('nl-NL', {
      style: 'unit',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      unit: 'meter'
    }),
    en: new Intl.NumberFormat('en-GB', {
      style: 'unit',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      unit: 'meter'
    })
  },
  currency: {
    nl: new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }),
    en: new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  },
  largeNumbers: {
    nl: new Intl.NumberFormat('nl-NL', {
      style: 'decimal',
      notation: 'standard',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }),
    en: new Intl.NumberFormat('en-GB', {
      style: 'decimal',
      notation: 'standard',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })
  }
}

export function formatDistance(distance: number) {
  const locale = useLocaleStore().locale
  if (distance >= 1) {
    return formatterMap.kilometer[locale].format(distance)
  } else {
    return formatterMap.meter[locale].format(distance * 1000)
  }
}

export function formatCurrency(amount?: MaybeRefOrGetter<number>): string {
  const locale = useLocaleStore().locale

  amount = toValue(amount)

  if (amount == null) {
    return formatterMap.currency[locale].format(0)
  }

  return formatterMap.currency[locale].format(amount)
}

export function formatThousands(amount?: number): string {
  if (amount == null) {
    return '-'
  }

  const locale = useLocaleStore().locale

  return formatterMap.largeNumbers[locale].format(amount)
}
